/** Largeurs fixes — sidebar principale refonte Woahda + panneau secondaire. */
export const PRIMARY_SIDEBAR_WIDTH_PX = 216;
export const SECONDARY_SIDEBAR_WIDTH_PX = 260;
